import { ForEnterpriseSections } from '../components/for-enterprise/ForEnterpriseSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildForEnterprisePageSchema } from '../lib/schema';
import { FOR_ENTERPRISE_META } from '../lib/seo';
import '../styles/solutions-landing.css';
import '../styles/for-enterprise.css';

export function ForEnterprisePage() {
  return (
    <>
      <PageSeo meta={FOR_ENTERPRISE_META} />
      <JsonLd data={buildForEnterprisePageSchema()} />
      <MarketingLandingShell>
        <ForEnterpriseSections />
      </MarketingLandingShell>
    </>
  );
}
